
/* eslint-disable class-methods-use-this */
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import myDashboardSVG from '@/assets/images/MyDashboard.svg';
import { SessionService } from '@/core/services/session';

const loanNamespace = namespace('loan');

@Component
export default class LoanNav extends Vue {
	public isLeftNavShown = false;

	public isRightNavShown = false;

	@loanNamespace.Getter('loanId')
	public loanId!: string | undefined;

	@Prop({ default: myDashboardSVG })
	public logo!: string;

	public logout(): void {
		SessionService.logout();
	}
}
